<template>

	<!-- content -->
	<div id="content" class="content board-write">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">게시글 작성</h2>
			</div>
			<!-- 작성 -->

			<form @submit.prevent="setBoard">
				<div class="write-form">
					<div class="gui-form">
						<div class="row-box">
							<label class="label" for="">제목</label>
							<div class="inp-set">
								<input id="" name="" type="text" placeholder="제목을 입력하세요." maxlength="150" v-model="boardVO.title" required>
							</div>
						</div>
						<div class="row-box" v-show="boardInfoVO.isCategory">
							<label class="label" for="">카테고리</label>
							<div class="inp-set">
								<select id="cateCode" name="cateCode" v-model="boardVO.cateCode" :required="boardInfoVO.isCategory">
								</select>
							</div>
						</div>
						<div class="row-box">
							<label class="label" for="">내용</label>
							<div class="txt-set" style="word-break: break-all;">
<!--								<textarea id="contentHtml" name="contentHtml" type="text" placeholder="내용을 입력하세요."></textarea>-->
								<summernote-frame ref="summernote" mode="form" :html="boardVO.contentHtml"></summernote-frame>
							</div>
						</div>

						<div class="row-box" v-if="fileList.length > 0">
							<div class="attach-box">
								<ul>
									<li v-for="(item, index) in fileList">
										<a @click="doDownload(item.fidx)">{{ item.filename }}</a>
										<a href="javascript:;" class="btn-close" @click="deleteFile(item)"><span class="blind">삭제</span></a>
									</li>
								</ul>
							</div>
						</div>

						<div class="row-box">
							<label class="label" for="">첨부파일</label>
							<div class="inp-btn-set">
<!--								<input class="blind" id="" name="" type="file">
								<input id="" name="" type="text">
								<button type="button">파일첨부</button>-->
								<div class="dropzone" id="dropzone"></div>
							</div>
						</div>

					</div>
				</div>
				<!-- 버튼 -->
				<div class="btn-area">
					<button type="submit" class="btn-lg btn-primary">등록</button>
					<button type="button" class="btn-lg btn-black m-l-5" @click="doCancel">취소</button>
				</div>
			</form>

		</div>
	</div>
	<!--//content -->

</template>

<script>
// import Summernote from 'summernote'
// import('summernote/dist/summernote.css')
// import('summernote/dist/summernote-bs4.css')

import Dropzone from "dropzone";
// Make sure Dropzone doesn't try to attach itself to the
// element automatically.
// This behaviour will change in future versions.
Dropzone.autoDiscover = false;

import "dropzone/dist/dropzone.css";


import $ from 'jquery'
import Qs from "qs";
import APIs from "@/commons/APIs";
import HWAPP from "@/commons/mixins/hwapp.mixin";
import SummernoteFrame from "@/components/display/summernoteFrame";


export default {
	name: "formDefault",
	components: {SummernoteFrame},
	props: {
	},
	mixins: [HWAPP],
	data() {

		return {

			boardInfoVO: new this.BoardInfoVO(),
			boardVO: new this.BoardVO(this.getSessionProc()),
			fileIdxs: [],
			fileList: [],
			isIOS: false,

		}
	},
	created() {

		!this.requireLogin(this, false)

		if ( this.stringUtils.isEmpty( this.$route.query.boardKey ) ) {
			this.swalUtils.gritter("error", "정상적인 접근이 아닙니다. 다시 시도해주세요.", "error")
				.then(() => {
					history.back()
				})
			return;
		}

	},
	mounted() {

		this.$nextTick(async () => {
			this.boardInfoVO = await this.getBoardInfo(this.$route.query.boardKey);

			if (this.$route.query.idx > 0) {
				this.boardVO = await this.getBoard();
				console.log("boardVO!!", this.boardVO)
			}

			this.initForm();
		})
	},
	methods: {

		initForm() {

			const self = this

			/**
			 * 게시판 기본양식 사용여부
			 */
			if ( typeof this.$route.query.idx == 'undefined' && this.boardInfoVO.isForm ) {
				this.boardVO.contentHtml = this.stringUtils.nl2br(this.boardInfoVO.formText)
			}

			new Dropzone("div#dropzone", {
				url: this.APIs.BOARD_FILES + "/upload",
				headers: {
					'Cache-Control': null,
					'X-Requested-With': null,
				},
				paramName: "files",
				autoProcessQueue: true,
				uploadMultiple: true,
				dictDefaultMessage: "이곳을 클릭하여 파일을 추가하세요.",
				//acceptedFiles: '.jpg,.jpeg,.png,.txt,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.hwp,.pdf,.doc,.docx,.zip,.gif', // 허용 확장자
				init: function () {
					this.on("sending", function (file, xhr, formData) {
						formData.append("bidx", self.boardVO.idx)
						formData.append("LOGIN_ID", self.getLoginId() )
					});
					this.on("sendingmultiple", function (file, xhr, formData) {
						console.log(file)
						console.log(xhr)
						console.log(formData)
					});
					this.on("successmultiple", function (files, response) {

						var message = '';
						if (response.status === "ok") {

							self.fileList.push(...response.fileList);

							for (var i = 0; i < response.fileList.length; i++) {
								if ( response.fileList[i].status ) {
									message = "File successfully saved. Thumbnail is: " + response.fileList[i].webPath + response.fileList[i].realfilename;
								} else {
									message = "File not saved. " + response.fileList[i].message;
								}

								// gritter(response.status, message)
								self.swalUtils.gritter(response.status, message, "info", 500)
							}

						}

					});
					this.on("errormultiple", function (files, response) {
						console.log(files)
						console.log(response)
					});
				}
			});


			/**
			 * 게시판 카테고리 사용시 조회
			 */
			if ( this.boardInfoVO.isCategory ) {
				this.codeUtils.code2Select("#cateCode", this.boardInfoVO.cateCode, {
					value: "",
					text : "카테고리를 선택해주세요",
				})
			}


			/**
			 * 스크롤 최상위 이동
			 */
			this.webUtils.scrollTo();

		},




		deleteFile ( _boardFileVO ) {

			var self = this
			self.swalUtils.fire("파일을 삭제하시겠습니까?", "해당파일의 현재 사용중인 파일링크도 모두 중지됩니다.\n삭제하시겠습니까?", "error", true)
				.then((res) => {

					if (res.isConfirmed) {
						self.axiosCaller.delete(self, self.APIs.BOARD_FILES + "/deleteFile", {
							fidx: _boardFileVO.fidx
						}, (res) => {

							const result = res.data
							if ( result.status === "ok" ) {

								const index = self.fileList.findIndex((item)=>{
									return item.fidx === _boardFileVO.fidx
								})
								if ( index > -1 ) self.fileList.splice(index, 1)

								self.swalUtils.gritter("삭제되었습니다.", "기존 사용되고 있는 링크는 동작되지 않습니다.", "info", 800);
							} else {
								self.swalUtils.gritter(result.status, result.msg, 800);
							}

						})

					}

				})

			//BOARDS_FILE + "/upload"

		},




		getBoard () {

			return new Promise((resolve, reject) => {

				this.$eventBus.$emit("startProgress", 2)
				this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardOne/" + this.$route.query.idx, {}, (res) => {
					this.$eventBus.$emit("doneProgress", 2)

					var result = res.data

					/**
					 * 로그인 사용자의 글인지 확인
					 */
					if ( result.boardVO.writerKey !== this.getLoginId() ) {
						this.swalUtils.gritter("error", "본인이 작성한 글이 아닙니다.", "error", 800)
							.then(() => {
								history.back();
							})
						reject()
					}

					resolve( result.boardVO )

				})
			})
		},


		setBoard(e) {

			e.preventDefault()
			this.boardVO.boardKey = this.boardInfoVO.boardKey
			this.boardVO.contentHtml = this.$refs.summernote.getHtml()
			this.boardVO.fileIdxs = this.fileIdxs.join(",")
			this.boardVO.thumbIdx = this.thumbIdx
			this.boardVO.isSendMail = (this.boardInfoVO.boardKey === 'company')

			if ( this.stringUtils.isEmpty( this.boardVO.boardKey ) ) {
				this.swalUtils.gritter("error", "정상적인 접근이 아닙니다. 다시 시도해주세요.", "error", 800)
					.then(() => {
						history.back();
					})
				return
			}

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARDS + "/setBoardOne", this.boardVO, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				console.log( result )
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "저장되었습니다", "success", 800)
						.then((res) => {
							history.back()
						})
				}
			}, (err) => {
				this.$eventBus.$emit("doneProgress")
				const msg = err?.response?.data?.msg || "요청이 너무 많습니다. 잠시 후 다시 시도해주세요."
				this.swalUtils.gritter("error", msg, "error", 3000)
			})

		},


		doCancel() {
			history.back();
			return;
		},

		doDownload(fidx) {
			if (this.appDevice() === "IOS") {
				webkit.messageHandlers.iOSFileDownload.postMessage(APIs.BOARD_FILES_DOWN + '/' + fidx)
				return;
			}
			location.href = APIs.BOARD_FILES_DOWN + '/' + fidx
		}

	},
	watch: {

		fileList (newVal, oldVal) {
			var self = this
			self.fileIdxs = []
			if ( newVal !== undefined) {
				newVal.forEach((file)=>{
					self.fileIdxs.push( file.fidx )
				})
				self.thumbIdx = self.fileIdxs[0]
			}
		},


	}

}
</script>

<style scoped>

</style>
